export default "__VITE_ASSET__nb5pVqQB__"